<template>
  <div>
    <a-result status="403" title="403" sub-title="抱歉，您无权访问此页面。">
      <template #extra>
        <a-button type="primary" @click="()=> $router.history.go(-1)"> 返回 </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>